export const SET_BWT = 'bwt/SET_BWT'
export const UPDATE_TABLE = 'bwt/UPDATE_TABLE'
export const SET_LOADING = 'bwt/SET_LOADING'
export const SET_LOCATION = 'bwt/SET_LOCATION'
export const SET_DATE = 'bwt/SET_DATE'
export const SET_COUNT = 'bwt/SET_COUNT'
export const SET_INDEXES = 'bwt/SET_INDEXES'
